import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';
import { CanDeactivateGuard } from '../../gards/can-deactivate-guard.service';

export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.FR.PRODUCTS,
    loadComponent: () =>
      import('./products.component').then((m) => m.ProductsComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.PRODUCTS + '/:slug/:id',
    loadComponent: () =>
      import('./product/product.component').then((m) => m.ProductComponent),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.PRODUCTS + '/:slug/:id/upsale',
    loadComponent: () =>
      import('./product-upsale/product-upsale.component').then(
        (m) => m.ProductUpsaleComponent,
      ),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.PRODUCTS,
    loadComponent: () =>
      import('./products.component').then((m) => m.ProductsComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.PRODUCTS + '/:slug/:id',
    loadComponent: () =>
      import('./product/product.component').then((m) => m.ProductComponent),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.PRODUCTS + '/:slug/:id/upsale',
    loadComponent: () =>
      import('./product-upsale/product-upsale.component').then(
        (m) => m.ProductUpsaleComponent,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductsModule {}
